import React from 'react';

import { Navigate, Outlet, useLocation } from 'react-router';
import { useRecoilValue } from 'recoil';

import { auth } from '@constants/state';

const Auth = () => {
    const { isLogin } = useRecoilValue(auth);
    const location = useLocation();
    return (
        <>
            {isLogin ? (
                <Outlet />
            ) : (
                <Navigate to="/login" state={{ from: location }} replace />
            )}
        </>
    );
};

export default Auth;
